import React from 'react'
import { Pagination } from '@mui/material'

const PageFilter = () => {
  return (
    <div className="pagination_table">
      <div>Showing 1 to 5 of 10 results</div>
      <Pagination
        count={10}
        page={1}
      />
    </div>
  )
}

export default PageFilter
